const REMOTE_FIELDS = [
    'primaryArtist',
    'secondaryArtist',
    'label',
    'category',
    'genre',
    'mood',
    'supplier',
    'campaign',
];

const HIDDEN_FOR_LABEL = ['label', 'mood', 'supplier', 'campaign'];

function asArray(value) {
    if (Array.isArray(value)) {
        return value.filter((item) => item !== null && item !== undefined && item !== '');
    }

    if (value === null || value === undefined || value === '') {
        return [];
    }

    return [value];
}

function asChoices(items) {
    return asArray(items).map((item) => {
        if (item && typeof item === 'object') {
            return {
                value: String(item.value ?? item.id ?? ''),
                label: String(item.label ?? item.text ?? item.value ?? item.id ?? ''),
            };
        }

        return { value: String(item), label: String(item) };
    }).filter((item) => item.value !== '');
}

export function remoteFieldsFor(payload) {
    const isLabel = Boolean(payload?.permissions?.is_label_user);

    return REMOTE_FIELDS.filter((field) => !isLabel || !HIDDEN_FOR_LABEL.includes(field));
}

export function catalogRemoteFieldsFor(payload) {
    return remoteFieldsFor(payload).filter((field) => field !== 'category');
}

export function normalizeProductListPayload(raw) {
    const source = raw && typeof raw === 'object' ? raw : {};
    const list = source.list && typeof source.list === 'object' ? source.list : {};
    const selected = source.selected && typeof source.selected === 'object' ? source.selected : {};
    const routes = source.routes && typeof source.routes === 'object' ? source.routes : {};

    const normalizedSelected = {};
    REMOTE_FIELDS.forEach((field) => {
        normalizedSelected[field] = asChoices(selected[field]);
    });

    return {
        mode: source.mode === 'create' || source.mode === 'show' ? source.mode : 'edit',
        list: {
            id: list.id ?? null,
            account_id: list.account_id ?? null,
            name: list.name ?? '',
            url: list.url ?? '',
            title: list.title ?? '',
            description: list.description ?? '',
            ean: asArray(list.ean),
            keyword: list.keyword ?? null,
            orchestra: list.orchestra ?? null,
            days: list.days ?? null,
            time: list.time ?? null,
            offer: Boolean(list.offer),
            available: Boolean(list.available),
            sort: list.sort ?? '',
            orderby: list.orderby ?? '',
            limits: list.limits ?? 0,
            min: list.min === null || list.min === undefined ? '0.00' : String(list.min),
            max: list.max === null || list.max === undefined ? '0.00' : String(list.max),
            preview_url: list.preview_url || routes.preview || '',
            category: asArray(list.category),
            genre: asArray(list.genre),
            mood: asArray(list.mood),
            campaign: asArray(list.campaign),
            primaryArtist: asArray(list.primaryArtist),
            supplier: asArray(list.supplier),
            label: asArray(list.label),
            secondaryArtist: asArray(list.secondaryArtist),
            property: asArray(list.property),
        },
        selected: normalizedSelected,
        options: source.options && typeof source.options === 'object' ? source.options : { sort: {}, time: {}, property: {} },
        labels: source.labels && typeof source.labels === 'object' ? source.labels : {},
        routes: {
            index: routes.index || '',
            store: routes.store || '',
            update: routes.update || '',
            show: routes.show || '',
            edit: routes.edit || '',
            slug_check: routes.slug_check || '',
            preview: routes.preview || list.preview_url || '',
            search: routes.search && typeof routes.search === 'object' ? routes.search : {},
        },
        permissions: {
            can_create: Boolean(source.permissions?.can_create),
            can_update: Boolean(source.permissions?.can_update),
            can_delete: Boolean(source.permissions?.can_delete),
            is_label_user: Boolean(source.permissions?.is_label_user),
        },
        slug_conflict: source.slug_conflict || null,
    };
}

export { REMOTE_FIELDS, HIDDEN_FOR_LABEL };
